goog.provide('el8.appshared.dialog.refileRxRefill');

goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.template.appshared.dialog.refileRxRefill');
goog.require('el8.util.amplitude.prescriptionFormHelpers');

el8.appshared.dialog.refileRxRefill = (function() {

    var selectedPatientItem = null;
    var rxRefillId = null;
    var successCb = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'File Rx Refill Request to Another Patient Chart',
        modal: true,
        autoHeight: true,
        contentFn: el8.template.appshared.dialog.refileRxRefill.content,
        showXButton: el8Globals.READ_ONLY
    });

    var mindreaderOpts = el8.appshared.mindreaderOpts.patient({
        selectFn: function(event, item) {
            selectedPatientItem = item;
            return false;
        }
    });

    var form = new el8.uiwidget.Form({
        validationSpec: {},
        fields: [
            {
                name: 'patient-name',
                type: 'input',
                infoText: 'type patient name...',
                newMindreader: true,
                mindreaderOpts: mindreaderOpts
            }
        ]
    });
    form.addButton('move', 'Re-file', function(form) {
        el8.util.amplitude.logCompleteRefileRenewalRequest('Re-file', el8.ptdata.rxRefillRequests.getById(rxRefillId).isMedicationControlled());
        if (selectedPatientItem) {
            $.el8_ajax({
                url: '/patient/' + selectedPatientItem.id +'/rxrefill/'+ rxRefillId +'/assign/',
                type: "POST",
                data: null,
                success: function(data) {
                    that.hide();
                    // Do proper refreshing
                    if (el8Globals['APP'] === 'home') {
                        if (successCb) { successCb(); }
                    } else if (el8Globals['APP'] === 'chart') {
                        el8.appchart.mainFeeds.reqAct.update();
                    }
                }
            });
        }
        else {
            el8.uiwidget.alert('Please select a patient chart before refiling.');
        }
    }, true);

    form.addCancelButton(function() {
        that.hide();
    }, false);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(_rxRefillId, _successCb) {
        rxRefillId = _rxRefillId;
        successCb = _successCb;
        super_show.call(that);
    };

    return that;

})();

